import React from 'react';
import { Reveal } from './Reveal';
import { pains } from '../data/content';
export function Gap() {
  return <section id="gap" className="border-b border-white/10" aria-labelledby="gap-title" data-id="element-62" data-mp="3gsrqveo2rh0e">
      <div className="mx-auto max-w-6xl px-6 py-24 lg:py-28" data-id="element-63" data-mp="3brua96ipqv10">
        <Reveal className="max-w-2xl" data-id="element-64" data-mp="3bugil8dfheka">
          <p className="text-sm text-zinc-500" data-id="element-65" data-mp="36ubwn2tr3rmo">El gap</p>
          <h2 id="gap-title" className="mt-5 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl" data-id="element-66" data-mp="36vwscvrsxgm4">
            Los tres agujeros por los que se escapa el dinero de una marca de
            suplementos.
          </h2>
        </Reveal>

        <div className="mt-16 border-t border-white/10" data-id="element-67" data-mp="2szrpbiz1gsky">
          {pains.map((pain, i) => <Reveal key={pain.number} delay={i * 0.05} data-id="element-68" data-mp="2o0ycztvhn7md" data-mpi={i}>
              <article className="grid gap-6 border-b border-white/10 py-10 lg:grid-cols-12 lg:gap-10 lg:py-12" data-id="element-69" data-mp="2j2wt56q8n49u">
                <div className="lg:col-span-1" data-id="element-70" data-mp="2e5ess4qadxdg">
                  <span className="font-mono text-sm text-zinc-600" data-id="element-71" data-mp="1yucb2doqu6w7">
                    0{pain.number}
                  </span>
                </div>
                <h3 className="text-xl font-semibold leading-snug tracking-[-0.01em] text-white lg:col-span-4 lg:text-2xl" data-id="element-72" data-mp="23mc4roe803kc">
                  {pain.title}
                </h3>
                <div className="lg:col-span-7" data-id="element-73" data-mp="1tu6bmbc8fg3k">
                  <p className="text-base leading-relaxed text-zinc-400" data-id="element-74" data-mp="1tsv88cmp8acz">
                    {pain.body}
                  </p>
                  <p className="mt-5 font-mono text-sm text-accent" data-id="element-75" data-mp="2mjdbperc4dqx">
                    {pain.symptom}
                  </p>
                </div>
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-76" data-mp="2cko36clbw5nc">
          <p className="mt-12 max-w-2xl text-lg leading-relaxed text-zinc-300" data-id="element-77" data-mp="2cjw9567dqfz6">
            Los tres son el mismo problema visto desde tres ángulos: estás
            comprando clientes a precio de mercado y monetizándolos una sola
            vez. El x7 no sale de bajar el CPA. Sale de{' '}
            <span className="text-white" data-id="element-78" data-mp="33sfx2a3watkr">
              poder pagar más que tu competencia por el mismo cliente
            </span>{' '}
            y seguir ganando dinero.
          </p>
        </Reveal>
      </div>
    </section>;
}